import mux from 'mux-embed'
import Link from 'next/link'
import { useRouter } from 'next/router'
import React, { useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'

interface ExerciseDetailHeroProps {
    mainImage: string
    video?: {
        videoUrl: string
        videoThumbUrl: string
        title: string
        id?: any
    }
    hasAccess: boolean
    challengeUrl: string
    trackProgress: (seconds: number) => void
}

export const ExerciseDetailHero = ({
    video,
    hasAccess,
    mainImage,
    challengeUrl,
    trackProgress
}: ExerciseDetailHeroProps) => {
    const [playing, setPlaying] = useState(false)
    const router = useRouter()
    const videoRef: any = useRef(null)

    useEffect(() => {
        if (videoRef.current !== null && playing) {
            const initTime = Date.now()
            mux.monitor('div.react-player video', {
                debug: false,
                data: {
                    env_key: process.env.NEXT_PUBLIC_MUX_ENV_KEY,
                    player_name: 'Exercise Detail Player',
                    player_init_time: initTime,
                    video_id: video?.id,
                    video_title: video?.title
                }
            })
        }
    }, [videoRef, playing])

    return (
        <div className="max-w-screen-fullHd mx-auto">
            <div className="aspect-w-16 aspect-h-9 relative">
                {hasAccess ? (
                    <>
                        {video !== null ? (
                            <ReactPlayer
                                ref={videoRef}
                                playIcon={
                                    <i className="fas fa-play text-7xl text-white z-10"></i>
                                }
                                playing={true}
                                muted
                                className="react-player"
                                width="100%"
                                height="100%"
                                url={video?.videoUrl}
                                light={video?.videoThumbUrl}
                                controls
                                onEnded={() => {
                                    videoRef?.current?.showPreview()
                                }}
                                onPlay={() => setPlaying(true)}
                                onPause={() => setPlaying(false)}
                                progressInterval={5000}
                                onProgress={({ playedSeconds }) => {
                                    trackProgress(playedSeconds)
                                }}
                            />
                        ) : (
                            <img
                                src={mainImage}
                                alt="Exercise hero image"
                                className="object-center object-contain bg-gray-200"
                            />
                        )}
                    </>
                ) : (
                    <img
                        src={mainImage}
                        alt="Exercise hero image"
                        className="object-center object-contain bg-gray-200"
                    />
                )}

                {!hasAccess ? (
                    <div className="flex items-center justify-center flex-col bg-black bg-opacity-60">
                        {!video ? (
                            <p>Missing Video</p>
                        ) : (
                            <>
                                <div className="flex items-center mb-5">
                                    <img
                                        src="/VIP-Full-Purple.svg"
                                        alt="premium svg"
                                        className="mr-2"
                                        width={75}
                                        height={75}
                                    />
                                </div>

                                <button
                                    onClick={() => void router.push('/membership')}
                                    className="bg-yf-purple text-white py-2 sm:py-4 rounded-lg w-3/5 sm:w-full max-w-sm mb-5 px-4 sm:px-0"
                                >
                                    Get Access Now
                                </button>

                                <p className="text-white text-lg sm:text-xl mb-5 sm: mb-0">
                                    Or{' '}
                                    <Link
                                        href={`/login?redirect=/exercises/${challengeUrl}`}
                                    >
                                        <a className="text-yf-green cursor-pointer font-normal">
                                            Sign In
                                        </a>
                                    </Link>{' '}
                                    to Continue
                                </p>
                            </>
                        )}
                    </div>
                ) : null}
            </div>
        </div>
    )
}
